var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginBadge1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.6197888,90 L19.5309388,90 C8.74429916,90 0,81.2695526 0,70.5 L0,19.5 C0,8.73044738 8.74429916,0 19.5309388,0 L75.6197888,0 L75.9633418,0.00295610657 C86.5914878,0.185984972 95.1507276,8.84501709 95.1507276,19.5 L95.1507276,27.629 L113.892697,40.924098 L114.075851,41.0601502 C116.701047,43.1013811 116.639996,47.1269667 113.892697,49.075902 L95.1507276,62.372 L95.1507276,70.5 C95.1507276,81.2695526 86.4064285,90 75.6197888,90 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.7%",
    y: "-6.1%",
    width: "111.2%",
    height: "114.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.6224265,5 C83.5389088,5 89.9762081,11.3221564 90.1442401,19.1846885 L90.1476064,19.5 L90.1476064,30.20951 L111,45 L90.1476064,59.79049 L90.1476064,70.5 C90.1476064,78.4027588 83.8144714,84.8288988 75.9382856,84.9966395 L75.6224265,85 L19.5251799,85 C11.6086977,85 5.17139835,78.6778436 5.00336632,70.8153115 L5,70.5 L5,19.5 C5,11.5972412 11.3331351,5.17110122 19.2093209,5.00336048 L19.5251799,5 L75.6224265,5 Z",
    id: "Path",
    fill: "#00CCFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4811408,10 L75.3699706,10 C80.6062601,10 84.8511114,14.2532949 84.8511114,19.5 L84.8511114,30.20951 L84.8575781,30.4642631 C84.9349615,31.9869428 85.7029455,33.3969445 86.950899,34.285412 L102,44.999 L86.950899,55.714588 C85.6336147,56.6524148 84.8511114,58.1713337 84.8511114,59.79049 L84.8511114,70.5 C84.8511114,75.7467051 80.6062601,80 75.3699706,80 L19.4811408,80 C14.2448513,80 10,75.7467051 10,70.5 L10,19.5 C10,14.2532949 14.2448513,10 19.4811408,10 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#00CCFF",
    x: 24,
    y: 27,
    width: 47,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#00CCFF",
    x: 24,
    y: 43,
    width: 47,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#00CCFF",
    x: 24,
    y: 59,
    width: 47,
    height: 5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBadge1);
export default __webpack_public_path__ + "static/media/login-badge-1.b3eccc4d75b6cb484e2069248032ae16.svg";
export { ForwardRef as ReactComponent };